import BaseModal from 'src/components/modals/base-modal/BaseModal';
import { TestIDs } from 'src/constants/testIDs.constants';
import { Illustration } from 'src/components/illustration/Illustration';
import { ILLUSTRATION_NAMES } from 'src/components/illustration/illustration.helper';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import { DynamicModalProps } from 'src/components/modals/dynamic-modals/DynamicModal.types';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { DYNAMIC_MODAL_ACTIONS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';

export const ModalNewVersionAvailable = observer(
  ({ type, dynamicModalVisible, dynamicModalLayer: { id, actionCallback } }: DynamicModalProps) => {
    const { i18n } = useStore();
    const { isMobile } = useResponsiveScreen();
    return (
      <BaseModal
        testID={TestIDs.NEW_VERSION_AVAILABLE}
        modalIcon={
          <Illustration
            name={ILLUSTRATION_NAMES.ReloadThePage}
            width={isMobile ? 54 : 64}
            height={isMobile ? 54 : 64}
          />
        }
        title={i18n.t('modal-new-version-available:title')}
        description={i18n.t('modal-new-version-available:description')}
        confirmText={i18n.t('modal-new-version-available:cta')}
        handleConfirm={() => {
          actionCallback(DYNAMIC_MODAL_ACTIONS.CONTINUE);
        }}
        isVisible={dynamicModalVisible}
        closeOnClickOutside={false}
        type={type}
        id={id ?? 'new-version-available-error'}
        modalWidth={460}
      ></BaseModal>
    );
  },
);
